import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminAttemptDetail = {
  pageTitle: "解答詳細",
  notFound: "該当する解答記録が見つかりません。",
  sections: {
    summary: "解答サマリー",
    deliverySnapshot: "配信スナップショット",
    scoreRecords: "採点記録",
    judgeSubmissions: "コード提出",
    environments: "環境インスタンス",
  },
  fields: {
    paperTitle: "試験用紙名",
    paperType: "試験用紙タイプ",
    paperVersionCode: "試験用紙バージョン番号",
    duration: "試験時間",
    examStartTime: "試験開始時刻",
    examEndTime: "試験終了時刻",
    deadlineAt: "解答締切時刻",
    earliestSubmitAt: "最早提出時刻",
    exam: "試験",
    candidate: "受験者",
    status: commonShortNouns.status,
    reviewStatus: "採点レビュー状態",
    totalScore: "合計点",
    scoreSplit: "客観 / 主観",
    startedAt: "開始時刻",
    submittedAt: "提出時刻",
    lastSavedAt: "最終保存",
    createdAt: commonShortFieldLabels.createdAt,
    questionId: "問題 ID",
    questionCode: "問題番号",
    versionId: "問題バージョン ID",
    versionCode: "バージョン番号",
    questionType: "問題タイプ",
    difficulty: "難易度",
    questionScore: "問題配点",
    source: "ソース",
    scoreSource: "採点ソース",
    score: "得点",
    comment: "コメント",
    time: "時間",
    submission: "提出",
    judgeStatus: "判定状態",
    instance: "インスタンス",
    type: "タイプ",
    accessEntry: "アクセス入口",
  },
  labels: {
    questionTitle: "第 {order} 問 · {title}",
    titleWithId: "解答 #{id}",
    sourceAuto: "自動採点",
    sourceManual: "手動採点",
    sourceReview: "レビュー採点",
    sourceUnknown: "不明なソース",
    statusValid: "有効",
    statusInvalid: "無効",
    statusPending: "反映待ち",
    statusUnknown: "不明",
    commentAutoObjective: "システムによる客観問題の自動採点",
    commentManualReview: "手動レビュー採点",
    examFallback: "試験 #{id}",
    candidateFallback: "受験者 #{id}",
    candidateId: "ID {id}",
    contentRef: "content_ref: {value}",
    policyShuffleQuestions: "問題シャッフル {value}",
    policyShuffleOptions: "選択肢シャッフル {value}",
    policySelfCheck: "セルフチェック {value}",
    policyMaxSelfCheckCount: "最大 {count} 回実行",
    policyMaxCreateCount: "最大 {count} 個の環境を作成",
    markCorrect: "正解",
    markCorrectRadioTip: "（左側のラジオボタンをクリックすると、正解としてマークされます）",
    markCorrectCheckboxTip: "（左側のチェックボックスを選択すると、正解としてマークされます）",
    practicalQuestionFallback: "実技問題デバッグ",
    attackDefenseQuestionFallback: "攻防問題デバッグ",
  },
  actions: {
    viewExam: "試験を表示",
    viewRawJson: "Raw JSON を表示",
    viewLatestAnswerJson: "解答 Raw JSON を表示",
    viewReferenceAnswerJson: "参考解答 Raw JSON を表示",
    viewQuestionSnapshotJson: "問題スナップショット Raw JSON を表示",
  },
  cards: {
    runtimePolicies: "問題タイプ実行ポリシー",
    questionSnapshotAndAnswer: "問題スナップショットと解答",
    questionPreview: "問題プレビュー",
    runtimePolicy: "実行ポリシー",
    answerResult: "解答結果",
    referenceAnswer: "参考解答",
  },
} as const;
